export default __webpack_public_path__ + "static/media/luxietech-full.be3665a1.png";